import { InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { MsalAuthenticationTemplate, MsalProvider } from '@azure/msal-react';
import { ThemeProvider } from '@mui/material';
import { LicenseInfo } from '@mui/x-license';
import { store } from '@redux/store';
import { loginRequest, msalConfig } from '@utils/authenticationMSAL/authConfig';
import ErrorComponent from '@utils/authenticationMSAL/ErrorComponent';
import LoadingComponent from '@utils/authenticationMSAL/LoadingComponent';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import { tsoPqTheme } from './assets/style/customTsoPqtheme';
import './index.css';

LicenseInfo.setLicenseKey(import.meta.env.VITE_UENBPQ_MUI_LICENSE);

export const pca = new PublicClientApplication(msalConfig);

pca
  .initialize()
  .then(() => {
    pca.handleRedirectPromise().then((response) => {
      if (response?.account) {
        pca.setActiveAccount(response.account);
      } else {
        // restore last active account on reload
        const active = pca.getActiveAccount();
        if (!active) {
          const all = pca.getAllAccounts();
          if (all.length === 1) {
            pca.setActiveAccount(all[0]);
          }
        }
      }
    });

    createRoot(document.getElementById('root')!).render(
      <StrictMode>
        <ThemeProvider theme={tsoPqTheme}>
          <Provider store={store}>
            <MsalProvider instance={pca}>
              <MsalAuthenticationTemplate
                interactionType={InteractionType.Redirect}
                authenticationRequest={loginRequest}
                errorComponent={ErrorComponent}
                loadingComponent={LoadingComponent}
              >
                <App />
              </MsalAuthenticationTemplate>
            </MsalProvider>
          </Provider>
        </ThemeProvider>
      </StrictMode>
    );
  })
  .catch((error) => {
    console.error('Failed to initialize MSAL', error);
  });
